import React from 'react';

import { useFormContext } from 'react-hook-form';

import { StoreBodyBlock } from 'constants/enums';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';
import {
  ETemplateStudioSidebarBlock,
  TemplateStudioBlock
} from 'state/template-studio.state.service';
import { z } from 'zod';

import { FormField } from 'components/ui';
import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

import { templateStudioSchema } from '../../../validation-schema';
import { ThemesFormItem } from '../Components/ThemesFormItem';

export const TemplateStudioDailyBonusForm: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();
  const {
    setOpenSecondarySidebarBlock,
    openSecondarySidebarBlock,
    supportedThemesForDailyBonus
  } = useTemplateStudioState();

  const toggleSecondarySidebar = (block: TemplateStudioBlock) => {
    setOpenSecondarySidebarBlock(undefined);
    if (openSecondarySidebarBlock !== block) {
      setTimeout(() => {
        setOpenSecondarySidebarBlock(block);
      }, 100);
    }
  };

  if (!supportedThemesForDailyBonus) return null;

  return (
    <>
      <FormField
        control={control}
        name="dailyBonusBadge.themes"
        render={({ field }) => (
          <ThemesFormItem
            onChange={field.onChange}
            value={field.value || []}
            supportedThemes={supportedThemesForDailyBonus}
            themesSelectDataTestId="TemplatesStudio-DailyBonus-themes"
          />
        )}
      />
      <div className="flex gap-2 mt-2 justify-between">
        <div className="text-sm">Element Type</div>
        <Tabs defaultValue="badge" orientation="vertical">
          <TabsList className="flex-col bg-base-muted h-[76px]">
            <TabsTrigger
              value="badge"
              onClick={() =>
                toggleSecondarySidebar(StoreBodyBlock.dailyBonusBadge)
              }
              className="h-[34px] w-[120px] data-[state=active]:bg-base-background data-[state=active]:text-indigo-500 text-base-mutedForeground"
            >
              Badge
            </TabsTrigger>
            <TabsTrigger
              value="popup"
              onClick={() =>
                toggleSecondarySidebar(ETemplateStudioSidebarBlock.POPUP)
              }
              className="h-[34px] w-[120px] data-[state=active]:bg-base-background data-[state=active]:text-indigo-500 text-base-mutedForeground"
            >
              Popup
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
    </>
  );
};
